'use client'

/* empty css                                     */
/* empty css                                        */
/* empty css                                     */
/* empty css                                      */
/* empty css                                      */
/* empty css                                         */
/* empty css                                          */
/* empty css                                   */
var wrapper = "c4-84-8_12hry2l0 c4-84-8_nly6ul0 c4-84-8_nly6ul10";
var container = "c4-84-8_12hry2l1 c4-84-8_194zije6 c4-84-8_194zijeg c4-84-8_194zijeq c4-84-8_194zije10 c4-84-8_nly6ul33 c4-84-8_nly6ul35 c4-84-8_nly6ul0 c4-84-8_nly6ul2s c4-84-8_161xunp0 c4-84-8_nly6ulk";
var background = { onLight: "c4-84-8_12hry2l2 c4-84-8_1dohnja6m", onDark: "c4-84-8_12hry2l3 c4-84-8_1dohnja70" };
var textWrapper = "c4-84-8_12hry2l5 c4-84-8_12hry2l4 c4-84-8_161xunp0 c4-84-8_nly6ulk";
var lastTextRow = "c4-84-8_12hry2l6";
var textSkeleton = "c4-84-8_12hry2l8 c4-84-8_12hry2l7 c4-84-8_nly6ulo";
var animation = "c4-84-8_12hry2la c4-84-8_1lxmpax6";
var animationBackground = { onLight: "c4-84-8_12hry2lb", onDark: "c4-84-8_12hry2lc" };
export {
  animation,
  animationBackground,
  background,
  container,
  lastTextRow,
  textSkeleton,
  textWrapper,
  wrapper
};
